import { __module as e } from "../../../_virtual/isIMEI.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(t = e.exports, "__esModule", {
  value: !0
}), t.default = function (e, r) {
  (0, s.default)(e);
  var t = a;
  if ((r = r || {}).allow_hyphens && (t = o), !t.test(e)) return !1;
  e = e.replace(/-/g, "");
  for (var u = 0, l = 2, d = 0; d < 14; d++) {
    var i = parseInt(e.substring(14 - d - 1, 14 - d), 10) * l;
    i >= 10 ? u += i % 10 + 1 : u += i, 1 === l ? l += 1 : l -= 1;
  }
  return (10 - u % 10) % 10 === parseInt(e.substring(14, 15), 10);
}, s = r && r.__esModule ? r : {
  default: r
}, a = /^[0-9]{15}$/, o = /^\d{2}-\d{6}-\d{6}-\d{1}$/, e.exports = t.default, e.exports.default = t.default;
var t,
  s,
  a,
  o,
  u = e.exports;
export { u as i };